import {
    Bar,
    DatafeedConfiguration,
    IBasicDataFeed,
} from '../charting_library/charting_library';
import {
    ErrorCallback,
    GetMarksCallback,
    HistoryCallback,
    HistoryDepth,
    LibrarySymbolInfo,
    Mark,
    OnReadyCallback,
    ResolutionBackValues,
    ResolutionString,
    ResolveCallback,
    SearchSymbolsCallback,
    ServerTimeCallback,
    SubscribeBarsCallback,
    TimescaleMark,
} from '../charting_library/datafeed-api';
import { getFirstData } from './getFirstData';
import { SocketClient } from '../services/SocketClient';
export interface DataSubscriber {
    symbolInfo: LibrarySymbolInfo;
    resolution: string;
    lastBarTime: number | null;
    listener: SubscribeBarsCallback;
}

export interface DataSubscribers {
    [guid: string]: DataSubscriber;
}

export class DataFeed implements IBasicDataFeed {
    private config: DatafeedConfiguration;
    private subscribers: DataSubscribers = {};
    private socket: SocketClient;
    constructor(config: DatafeedConfiguration) {
        this.config = config;
        this.socket = new SocketClient('ws/btcusdt@kline_1m');
    }

    onReady(callback: OnReadyCallback) {
        console.log('Inside on ready');
        setTimeout(() => callback(this.config), 0);
    }
    searchSymbols(
        userInput: string,
        exchange: string,
        symbolType: string,
        onResult: SearchSymbolsCallback
    ) {
        console.log('Search Symbols running');
    }
    resolveSymbol(
        symbolName: string,
        onResolve: ResolveCallback,
        onError: ErrorCallback
    ) {
        var splitData = symbolName.split(/[:/]/);

        const symbolStub: LibrarySymbolInfo = {
            name: 'BTCUSDT',
            full_name: 'BTCUSDT',
            description: `BTC / USDT`,
            type: 'crypto',
            session: '24x7',
            timezone: 'Etc/UTC',
            ticker: 'BTCUSDT',
            exchange: 'Binance',
            minmov: 1,
            pricescale: 100000000,
            has_intraday: true,
            format: 'price',
            intraday_multipliers: ['1'],
            supported_resolutions: ['1', '3', '5'] as ResolutionString[],
            volume_precision: 8,
            listed_exchange: 'Binance Market',
        };
        setTimeout(() => {
            onResolve(symbolStub);
        }, 0);
    }
    getBars(
        symbolInfo: LibrarySymbolInfo,
        resolution: ResolutionString,
        rangeStartDate: number,
        rangeEndDate: number,
        onResult: HistoryCallback,
        onError: ErrorCallback,
        isFirstCall: boolean
    ) {
        /*console.log('getBars method running');
        console.log(
            `symbolinfo ${JSON.stringify(
                symbolInfo
            )} resolution ${resolution} from ${rangeStartDate} to ${rangeEndDate}`
        );*/
        // console.log('function args',arguments)
        // console.log(`Requesting bars between ${new Date(from * 1000).toISOString()} and ${new Date(to * 1000).toISOString()}`)
        /*const split_symbol = symbolInfo.name.split(/[:/]/);
        let tempResolution = 1440;
        if (resolution == '1D') {
            tempResolution = 1440;
        }
        if (resolution == '3D') {
            tempResolution = 4320;
        }*/
        // sending 2000 default limit

        const totalRange = rangeEndDate - rangeStartDate;
        const totalBars = totalRange / (parseInt(resolution) * 60);
        const requestCount = Math.ceil(totalBars / 800);
        const standardAdditionalTime = 1000 * (parseInt(resolution) * 60);
        //console.log('rangeEndDate', rangeEndDate);
        let totalResults: Array<Bar> = [];
        let completedResults: number = 0;
        for (let i = 0; i < requestCount; i++) {
            let tempRangeStart =
                rangeStartDate * 1000 + (800*standardAdditionalTime * i);
            let tempRangeEndDate =
                rangeStartDate * 1000 + (800*standardAdditionalTime * (i + 1));
            if (tempRangeEndDate > rangeEndDate * 1000) tempRangeEndDate = rangeEndDate * 1000;
            //console.log('i',i);
            getFirstData(
                symbolInfo.name,
                parseInt(resolution),
                tempRangeStart,
                tempRangeEndDate,
                'USDT'
            ).then((result) => {
                totalResults.push(...result);
                completedResults++;
                console.log('completedResults',completedResults)
                if(completedResults === requestCount)
                    onResult(totalResults.sort((a,b) => a.time - b.time), { noData: false });

                // if (isFirstCall) this.lastBar = result[result.length - 1];
                if (this.socket.isHandlerExist('kline') === undefined) {
                    this.socket.setHandler('kline', (data: any) => {
                        console.log(data);
                        this.updateKLine({
                            time: data.t,
                            open: data.o,
                            high: data.h,
                            low: data.l,
                            close: data.c,
                            volume: data.v,
                        });
                    });
                }
            });
        }

        /*this.tradeHistory
            .getBars(symbolInfo, resolution, rangeStartDate, rangeEndDate, isFirstCall, 2000)
            .subscribe((data) => {
                console.log({ data });
                if (data.Response && data.Response === 'Error') {
                    console.log(
                        'CryptoCompare data fetching error :',
                        data.Message
                    );
                    onHistoryCallback([], { noData: true });
                }
                if (data.Data.length) {
                    var bars = data.Data.map((el) => {
                        return {
                            time: el.time * 1000,
                            low: el.low,
                            high: el.high,
                            open: el.open,
                            close: el.close,
                            volume: el.volumefrom,
                        };
                    });
                    if (firstDataRequest) {
                        var lastBar = bars[bars.length - 1];
                        history[symbolInfo.name] = { lastBar: lastBar };
                    }
                    if (bars.length) {
                        onHistoryCallback(bars, { noData: false });
                    } else {
                        onHistoryCallback([], { noData: true });
                    }
                } else {
                    onHistoryCallback([], { noData: true });
                }
            });*/
    }
    subscribeBars(
        symbolInfo: LibrarySymbolInfo,
        resolution: ResolutionString,
        onTick: SubscribeBarsCallback,
        listenerGuid: string,
        onResetCacheNeededCallback: () => void
    ) {
        if (this.subscribers[listenerGuid]) {
            return;
        }
        this.subscribers[listenerGuid] = {
            lastBarTime: null,
            listener: onTick,
            resolution: resolution,
            symbolInfo: symbolInfo,
        };
        /* console.log('subscribeBars Runnning');
        this.socketService.subscribeBars(
            symbolInfo,
            resolution,
            onTick,
            listenerGuid,
            onResetCacheNeededCallback,
            this.lastBar
        ); */
    }
    public unsubscribeBars(subscriberUID: string) {
        if (!this.subscribers[subscriberUID]) {
            return;
        }
        delete this.subscribers[subscriberUID];
    }

    public updateKLine(bar: Bar) {
        for (const listenerGuid in this.subscribers) {
            const subscriptionRecord = this.subscribers[listenerGuid];
            if (
                subscriptionRecord.lastBarTime !== null &&
                bar.time < subscriptionRecord.lastBarTime
            ) {
                continue;
            }
            subscriptionRecord.lastBarTime = bar.time;
            subscriptionRecord.listener(bar);
        }
    }

    /*
    unsubscribeBars(listenerGuid: string) {
        console.log('unsubscribeBars Running');

        this.socketService.unsubscribeBars(listenerGuid);
    } */

    calculateHistoryDepth(
        resolution: ResolutionString,
        resolutionBack: ResolutionBackValues,
        intervalBack: number
    ): HistoryDepth | undefined {

        return {
            resolutionBack: 'D',
            intervalBack: 4,
        };
        return undefined;

    }
    getMarks(
        symbolInfo: LibrarySymbolInfo,
        from: number,
        to: number,
        onDataCallback: GetMarksCallback<Mark>,
        resolution: ResolutionString
    ): void {
        // optional
        //console.log('getMarks Running');
    }
    getTimescaleMarks(
        symbolInfo: LibrarySymbolInfo,
        from: number,
        to: number,
        onDataCallback: GetMarksCallback<TimescaleMark>,
        resolution: ResolutionString
    ): void {
        // optional
        //console.log('getTimeScaleMarks Running');
    }
    getServerTime(callback: ServerTimeCallback): void {
        //console.log('getServerTime Running');
    }
}



// WEBPACK FOOTER //
// ./src/services/datafeed.ts